import {
  BackendProductStatus,
  LegacyProductStatus,
  ProductStatus,
} from '@/modules/product/types';

export function isOnSale(
  productStatus:
    ProductStatus | LegacyProductStatus | BackendProductStatus | string
) {
  return (
    productStatus === ProductStatus.ONSALE ||
    productStatus === LegacyProductStatus.ONSALE ||
    productStatus === BackendProductStatus.ONSALE ||
    productStatus === BackendProductStatus.ONSALE
  );
}
